/* script */
export * from "!!babel-loader!../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@6.26.3_supports-color@5.5.0__css-loader@0.28.11_handlebars_113b7769537605c3d521a8736433f671/node_modules/vue-loader/lib/selector?type=script&index=0!./validate-email.vue"
import __vue_script__ from "!!babel-loader!../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@6.26.3_supports-color@5.5.0__css-loader@0.28.11_handlebars_113b7769537605c3d521a8736433f671/node_modules/vue-loader/lib/selector?type=script&index=0!./validate-email.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@6.26.3_supports-color@5.5.0__css-loader@0.28.11_handlebars_113b7769537605c3d521a8736433f671/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-543211a5\",\"hasScoped\":false,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@6.26.3_supports-color@5.5.0__css-loader@0.28.11_handlebars_113b7769537605c3d521a8736433f671/node_modules/vue-loader/lib/selector?type=template&index=0!./validate-email.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@6.26.3_supports-color@5.5.0__css-loader@0.28.11_handlebars_113b7769537605c3d521a8736433f671/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/validate-email/validate-email.vue
// module id = null
// module chunks = 